import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSchemaHistory } from "./useSchemaHistory";

import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  BotMessageSquare,
  Dices,
  CopyPlus,
  CornerUpLeftIcon,
  CornerUpRight,
  Trash2,
  CornerRightUp,
  CornerLeftDown,
  Pencil,
  ChartBar,
  CheckIcon,
  CheckCheck,
  Palette,
  Minus,
  Circle,
  Squircle,
  Square,
  ArrowLeftRight,
  Grid2x2Check} from 'lucide-react';

import Loading from "../../Loading/Loading"; 

import loadable from '@loadable/component';
import CRMLogin from "../../CRM/CRMlogin";
import "./MobileApp/MobileFrame.css"; 
import ColorPalette from "../../UI/ColorPicker/ColorPalette";
import AppMenuCard from "./Cards/AppMenuCard";
import ItemCardAppDesign from "./Cards/ItemCardAppDesign";
import { appDesignSettings } from "../../../store/actions/CreateApp/appDesignSettings";
import DesignColorAll from "./DesignColorAll";
import DesignContentAll from "./DesignContentAll";
import MobileFrameInner from "./MobileApp/MobileFrameInner";
import DesignElements from "./DesignElements";
import AppMenuCardTwo from "./Cards/AppMenuCardTwo";
import ListUISettings from "./DesignElements/ListUISettings";
import ListUI from "./DesignElements/ListUI";
// npm i @loadable/component 

import element1 from "../../img/element1.png"
import element2 from "../../img/element2.png"
import element3 from "../../img/element3.png"
import UIBlockRenderer from "./UIBlockRenderer";
import RangeSliderBorderRadius from "../../UI/RangeSliderBorderRadius";
import ListUISettingsLoading from "./DesignElements/ListUISettingsLoading";
let lazyLoad =   <Loading/>;
  
  const Navber = loadable(() => import("../../../Navbar/UserMenu"), {
    fallback: lazyLoad  });
  
    
  
 const AppSettings = ()=>{
      const {url}=useRouteMatch();
   

         const [snackbarVisible, setSnackbarVisible] = useState(false);
         const [snackbarColor, setSnackbarColor] = useState("#958FDA");
         const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
         const [activeCardDesign, setActiveCardDesign] =useState(false);
         const [activeCardScreens, setActiveCardScreens] =useState(false);
         const [activeCardElements, setActiveCardElements] =useState(true); 
         const [activeCardSettings, setActiveCardSettings] =useState(false);   
         const [fixMenuAppRight, closeFixMenuAppRight] =useState(false);   
          const [openAppDesignPopUpInn,setopenAppDesignPopUpInn]  = useState(false);
        
         const rightFixClose =fixMenuAppRight?"visible":"hidden";
         const rightFixOpen =fixMenuAppRight?"hidden":"visible";
         const fixMenuAppRightHide={width:"70px",visibility:rightFixClose,height:"80px"}
         const fixMenuAppRightShow={width:"70px",visibility:rightFixOpen,}
       
         const [designContent, openDesignContent] =useState(false);      
           const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
         const [deviceWidth,setDeviceWidth] = useState(false);
         const bottomDivRef = useRef(null);
         
         const bottomDivBoxRef = useRef(null);
         const bodyWidthForMobile =useRef(null)
         
         const [isVisible, setIsVisible] = useState(false);
       
         const [divHeight, setDivHeight] = useState(0);
             
        useEffect(() => {
        
           if (bodyWidthForMobile.current) {
             let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
               setDeviceWidth(offsetWidth)
           }
           setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
           const observer = new IntersectionObserver(
             ([entry]) => {
               if (entry.isIntersecting) {
                 setIsVisible(true); // Set state when the div appears
               } else {
                 setIsVisible(false); // Reset state if it goes out of view
               }
             },
             {
               root: null, // Observe within the viewport
               threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
             }
           );
       
           if (bottomDivRef.current) {
             observer.observe(bottomDivRef.current);
           }
       
           return () => {
             if (bottomDivRef.current) {
               observer.unobserve(bottomDivRef.current);
             }
           };
         }, [deviceWidth])
       const showSnackbar = () => {
         setSnackbarVisible(true);
       };
      
       const hideSnackbar = () => {
         setSnackbarVisible(false);
       };
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
     ;
         const [loader , setLoader] =useState({status:false});
       const [animate, setAnimate] = useState(false); 
       const [openPopUp, setOpenPopUp] = useState(""); 
       
       useEffect(() => {
               
       
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
       
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
       
       
  const history = useHistory();
      const dispatch = useDispatch();
 const [screenBackground , setScreenBackground]=useState("rgba(144, 202, 249,0.2)")
   const [scrollItems, setScrollItems] = useState("Grid");// dark /faint
                        const [columnsList, setColumnsList] = useState(3);// black / white
                        const [fontFamily, setFontFamily] = useState({name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 });// black / white
                       const [fontWeight, setFontWeight] = useState("700");// black / white
                      const [hideReduUnDo, setHideReduUnDo] = useState(false);
                       const [iWidth, setiWidth] = useState("90%");
                        const [iHeight, setiHeight] = useState(80);
                        const [titleFontSize, setTitleFontSize] = useState(14);
                        const [subTitleFontSize, setSubTitleFontSize] = useState(10);
                        const [titleFontColor, setTitleFontColor] = useState({});
                        const [subTitleFontColor, setSubTitleFontColor] = useState({});
                        
                        const [titleFontWeight, setTitleFontWeight] = useState(600);
                        const [subTitleFontWeight, setSubTitleFontWeight] = useState(500);
                        
                       const [borderRadius, setBorderRadius] = useState(100);
                       const [marginLeft, setmarginLeft] = useState(10);
                      const [marginTop, setmarginTop] = useState(10);
                      const [marginBottom, setmarginBottom] = useState(10);
                       const [imarginLeft, setimarginLeft] = useState(18);
                      const [imarginTop, setimarginTop] = useState(5);
                      const [aspectRatio, setAspectRatio] = useState(4/3);
                       const [showTitle, setShowTitle] = useState(true);
                       const [showSubTitle, setShowSubTitle] = useState(false);
                       const [textAlignment, setTextAlignment] = useState("center");
                       const [textPosition, setTextPosition] = useState("onImage");
                       const [applyOverlay, setApplyOverlay] = useState(false);
                       const [overlayTitleFontColor, setOverlayTitleFontColor] = useState("rgba(219, 236, 229,1)");
                       const [overlayBG, setOverlayBG] = useState("rgba(144, 202, 249,0.15)");
                       const [absoluteHorizontal, setAbsoluteHorizontal] = useState("left");
                       const [absoluteHorizontalMargin, setAbsoluteHorizontalMargin] = useState(0);
                       const [absoluteVertical, setAbsoluteVertical] = useState("top");
                       const [absoluteVerticalMargin, setAbsoluteVerticalMargin] = useState(10);
                       const [itemVisibility, setItemVisibility,] = useState("Both");
                        
                       const [itemBackground, setItemBackground] = useState("");
                      
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.RecentAppToken);
const AppId = useSelector((state)=>state?.app?.app?.AppId);
const AppDesign = useSelector((state)=>state?.app?.appDesign);

const user_email = useSelector((state)=>state?.user?.user?.user_email);
const user = useSelector((state)=>state?.user?.user);

 const [dynamicId, setDynamicId] = useState("");
const [dynamicIdChange, setDynamicIdChange] = useState(true);
const [currentItem, setCurrentItem] = useState({});
 
       const [reloadItems, setReloadItems] = useState(true);
                const imagesList1 = [
                   { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1664541336896-b3d5f7dec9a3?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                             { id: 5,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 6,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                ];
                    const imagesList2 = [
                    { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/139.png" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/8.png" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/13.png" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/11.png" },
                 ];
                    
                 const imagesList3 = [
                    { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/img1.png" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013542.png" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013732.png" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013755.png" },
                // { id: 5, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013742.png" },
                 ];



  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
const itemArrLoads=[{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}];
   const [itemArrLoading, setItemArrLoading] = useState(itemArrLoads);
            const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):[];


  const initialSchema =[{ no:1, id: generateTimestamp(),itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}
          ,images:imagesList1,myKey:"id-list1-1",columns:5,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
         fontWeight:"700",iWidth:100,iHeight:80,
          titleFontSize:11, titleFontColor:{color:"rgba(254, 255, 255, 0.93)",alpha:1}, subTitleFontSize:8, subTitleFontColor:{color:"rgb(243, 247, 250)",alpha:1},
      titleFontWeight:"600", subTitleFontWeight:"500",showTitle:false, showSubTitle:false, 
          borderRadius:{value:50,resolution:"px"}, marginLeft:10,scrollItems:"Scroll",
          marginTop:10, marginBottom:10, imarginLeft:18, imarginTop:5, aspectRatio:"1/1",  textAlignment:"center"
          ,absoluteHorizontal:"",absoluteVertical:"bottom",absoluteHorizontalMargin:10,absoluteVerticalMargin:30,
          textPosition:"onImage",applyOverlay:false,overlayBG:{color:"rgba(54, 57, 60, 0.15)",alpha:1}
          ,overlayTitleFontColor:{color:"rgba(244, 250, 244, 1)",alpha:1},itemVisibility:"Both"
        },{ no:2, id: generateTimestamp()+1,itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}
          ,images:imagesList1,myKey:"id-list1-2",columns:2,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
         fontWeight:"700",iWidth:100,iHeight:80,
          titleFontSize:11, titleFontColor:{color:"rgba(23, 25, 25, 0.83)",alpha:1}, subTitleFontSize:8, subTitleFontColor:{color:"rgba(54, 55, 56,1)",alpha:1},
      titleFontWeight:"600", subTitleFontWeight:"500",showTitle:true, showSubTitle:true, 
          borderRadius:{value:10,resolution:"px"}, marginLeft:10,scrollItems:"Scroll",
          marginTop:10,marginBottom:10,  imarginLeft:18, imarginTop:5, aspectRatio:"3/4",  textAlignment:"center"
          ,absoluteHorizontal:"",absoluteVertical:"bottom",absoluteHorizontalMargin:10,absoluteVerticalMargin:5,
          textPosition:"onImage",applyOverlay:true,overlayBG:{color:"rgba(39, 30, 30, 0.47)",alpha:0.5},
          overlayTitleFontColor:{color:"rgba(244, 250, 244, 1)",alpha:1},itemVisibility:"Both"
        },{ no:3, id: generateTimestamp()+2,itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}
          ,images:imagesList1,myKey:"id-list1-3",columns:3,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
         fontWeight:"700",iWidth:100,iHeight:80,
          titleFontSize:10, titleFontColor:{color:"rgba(23, 25, 25, 0.83)",alpha:1}, subTitleFontSize:8, subTitleFontColor:{color:"rgba(54, 55, 56,1)",alpha:1},
      titleFontWeight:"600", subTitleFontWeight:"500",showTitle:true, showSubTitle:true, 
          borderRadius:{value:5,resolution:"px"}, marginLeft:10,scrollItems:"Grid",
          marginTop:10,marginBottom:10,  imarginLeft:18, imarginTop:5, aspectRatio:"2/1",  textAlignment:"left"
          ,absoluteHorizontal:"",absoluteVertical:"bottom",absoluteHorizontalMargin:10,absoluteVerticalMargin:5,
          textPosition:"below",applyOverlay:false,overlayBG:{color:"rgba(39, 30, 30, 0.47)",alpha:0.5}
          ,overlayTitleFontColor:{color:"rgba(244, 250, 244, 1)",alpha:1},itemVisibility:"Both", 
        },{ no:4, id: generateTimestamp()+3,itemBackground:{color:"rgba(253, 255, 253, 0.96)",alpha:1}
          ,images:imagesList3,myKey:"id-list2-4",columns:2,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
         fontWeight:"700",iWidth:100,iHeight:80,
        titleFontSize:11, titleFontColor:{color:"rgba(20, 21, 21, 0.96)",alpha:1}, subTitleFontSize:8, subTitleFontColor:{color:"rgba(22, 22, 23, 0.96)",alpha:1},
         titleFontWeight:"600", subTitleFontWeight:"500",showTitle:true, showSubTitle:true, 
          borderRadius:{value:0,resolution:"px"}, marginLeft:10,scrollItems:"Grid",
          marginTop:10,marginBottom:10,  imarginLeft:18, imarginTop:5, aspectRatio:"2/1",  textAlignment:"left"
           ,absoluteHorizontal:"left",absoluteVertical:"top",absoluteHorizontalMargin:10,absoluteVerticalMargin:10,
           textPosition:"below",applyOverlay:false,overlayBG:{color:"rgba(43, 44, 45, 0.75)",alpha:1},
           overlayTitleFontColor:{color:"rgba(244, 250, 244, 1)",alpha:1},itemVisibility:"Both",
        },]
const {
    currentSchema,
    updateSchema,
    undo,
    redo,
    reset,
    canUndo,
    canRedo,clearHistoryBeforeCurrent,currentIndex
  } = useSchemaHistory(initialSchema);
  
const [itemArr, setItemArr] = useState(initialSchema);
const handleBlockUpdate = (object) => {
  // const newSchema = [...itemArr];   // Step 1: Copy current schema
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.no === object?.no) {
        return {
          ...item };
      }
     
      return item;
    });
   updateSchema(updatedItems);
  // setItemArr(newSchema);
    return updatedItems;
  });
 
   
};
const[item, setItem]= useState({});

     useEffect(() => {
      
        // console.log(currentSchema)
    const index = currentSchema.findIndex(item => item.id === currentItem.id);
  //  setCurrentObject(index,currentSchema[index])
  // setCurrentItem(currentSchema[index])
        // alert(currentSchema[0]?.columns)
        //  setItemArr(currentSchema)
// setItemArr((prev) => {
//     const updatedItems = prev.map(item => {
      
     
//       return item;
//     });
  
//     return currentSchema;
//   });
        //  alert(itemArr[0]?.columns)
       // Trigger the animation after a delay (e.g., 500ms)
     
       const timer = setTimeout(() => {
        setAnimate(true);    
      }, 0);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, [currentIndex]);
 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
        
      };
      const updateItemmyKey = (id, myKey) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, myKey :myKey } : item
        
        ); 
        
        setItemArr(updatedItems);
        
      };
     
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};
const extractElementType = (str) => {
  const match = str?.match(/^.*?-(.*?)-.*$/);
  return match ? match[1] : null;
};
useEffect(() => {
//  const columnsMap = {};
//   itemArr.forEach(item => {  columnsMap[item.myKey] = item?.columns;}); setColumnsList(columnsMap);
  
//   const scrollItemsMap= {};
//   itemArr.forEach(item => { scrollItemsMap[item.myKey] = item?.scrollItems;});setScrollItems(scrollItemsMap);

//   const setTitleFontSizeMap= {};
//   itemArr.forEach(item => {setTitleFontSizeMap[item.myKey] = item?.titleFontSize; });setTitleFontSize(setTitleFontSizeMap);

//   const setTitleFontColorMap= {};
//   itemArr.forEach(item => {setTitleFontColorMap[item.myKey] = item?.titleFontColor; }); setTitleFontColor(setTitleFontColorMap);

//   const setSubTitleFontSizeMap= {};
//   itemArr.forEach(item => { setSubTitleFontSizeMap[item.myKey] = item?.subTitleFontSize;});setSubTitleFontSize(setSubTitleFontSizeMap);

//   const setSubTitleFontColorMap= {};
//   itemArr.forEach(item => {setSubTitleFontColorMap[item.myKey] = item?.subTitleFontColor;}); setSubTitleFontColor(setSubTitleFontColorMap);

//   const setTitleFontWeightMap= {};
//   itemArr.forEach(item => { setTitleFontWeightMap[item.myKey] = item?.titleFontWeight;});setTitleFontWeight(setTitleFontWeightMap);

//   const setSubTitleFontWeightMap= {};
//   itemArr.forEach(item => {setSubTitleFontWeightMap[item.myKey] = item?.subTitleFontWeight;});setSubTitleFontWeight(setSubTitleFontWeightMap);

//   const setShowTitleMap= {};
//   itemArr.forEach(item => { setShowTitleMap[item.myKey] = item?.showTitle;}); setShowTitle(setShowTitleMap);

//   const setShowSubTitleMap= {};
//   itemArr.forEach(item => { setShowSubTitleMap[item.myKey] = item?.showSubTitle; });setShowSubTitle(setShowSubTitleMap);

//   const setAspectRatioMap= {};
//   itemArr.forEach(item => {setAspectRatioMap[item.myKey] = item?.aspectRatio;}); setAspectRatio(setAspectRatioMap);

//   const setiMarginLeftMap= {};
//   itemArr.forEach(item => { setiMarginLeftMap[item.myKey] = item?.imarginLeft;}); setimarginLeft(setiMarginLeftMap);
//   const setiMarginTopMap= {};
//   itemArr.forEach(item => {  setiMarginTopMap[item.myKey] = item?.imarginTop;});  setimarginTop(setiMarginTopMap);

// const setMarginLeftMap= {};
//   itemArr.forEach(item => {setMarginLeftMap[item.myKey] = item?.marginLeft; });  setmarginLeft(setMarginLeftMap);

// const setMarginTopMap= {};
//   itemArr.forEach(item => { setMarginTopMap[item.myKey] = item?.marginTop;}); setmarginTop(setMarginTopMap);

// const setMarginBottomMap= {};
//   itemArr.forEach(item => { setMarginBottomMap[item.myKey] = item?.marginBottom;}); setmarginBottom(setMarginBottomMap);

// const setBorderRadiusMap= {};
//   itemArr.forEach(item => {  setBorderRadiusMap[item.myKey] = item?.borderRadius;  }); setBorderRadius(setBorderRadiusMap);

// const setFontFamilyMap= {};
//   itemArr.forEach(item => { setFontFamilyMap[item.myKey] = item?.fontFamily;  }); setFontFamily(setFontFamilyMap);

// const setTextAlignmentMap= {};
//   itemArr.forEach(item => {setTextAlignmentMap[item.myKey] = item?.textAlignment; }); setTextAlignment(setTextAlignmentMap);
  
// const setItemBackgroundMap= {};
//   itemArr.forEach(item => { setItemBackgroundMap[item.myKey] = item?.itemBackground; }); setItemBackground(setItemBackgroundMap);

// const setiWidthMap= {};
//   itemArr.forEach(item => {  setiWidthMap[item.myKey] = item?.iWidth;}); setiWidth(setiWidthMap);

// const setTextPositionMap= {};
//   itemArr.forEach(item => {  setTextPositionMap[item.myKey] = item?.textPosition;}); setTextPosition(setTextPositionMap);
// const setApplyOverlayMap= {};
//   itemArr.forEach(item => {  setApplyOverlayMap[item.myKey] = item?.applyOverlay;}); setApplyOverlay(setApplyOverlayMap);
// const setOverlayBGMap= {};
//   itemArr.forEach(item => {  setOverlayBGMap[item.myKey] = item?.overlayBG;}); setOverlayBG(setOverlayBGMap);
// const setItemVisibilityMap= {};
//   itemArr.forEach(item => {  setItemVisibilityMap[item.myKey] = item?.itemVisibility;}); setItemVisibility(setItemVisibilityMap);
// const setOverlayTitleFontColorMap= {};
//   itemArr.forEach(item => {  setOverlayTitleFontColorMap[item.myKey] = item?.overlayTitleFontColor;}); setOverlayTitleFontColor(setOverlayTitleFontColorMap);

// const setAbsoluteHorizontalMap= {};
//   itemArr.forEach(item => {  setAbsoluteHorizontalMap[item.myKey] = item?.absoluteHorizontal;}); setAbsoluteHorizontal(setAbsoluteHorizontalMap);
//   const setAbsoluteHorizontalMarginMap= {};
//   itemArr.forEach(item => {  setAbsoluteHorizontalMarginMap[item.myKey] = item?.absoluteHorizontalMargin;}); setAbsoluteHorizontalMargin(setAbsoluteHorizontalMarginMap);
//   const setAbsoluteVerticalMap= {};
//   itemArr.forEach(item => {  setAbsoluteVerticalMap[item.myKey] = item?.absoluteVertical;}); setAbsoluteVertical(setAbsoluteVerticalMap);
//   const setAbsoluteVerticalMarginMap= {};
//   itemArr.forEach(item => {  setAbsoluteVerticalMarginMap[item.myKey] = item?.absoluteVerticalMargin;}); setAbsoluteVerticalMargin(setAbsoluteVerticalMarginMap);
//     // loading First Item Dynamic Id  
 
   setDynamicId(itemArr[0]?.myKey) 

   setCurrentItem(itemArr[0]) 
   //- states take delays so use setTimeOut
   setDynamicIdChange(false);setItemArrLoading(itemArrLoads)
 const timer= setTimeout(()=>{ setDynamicIdChange(true);setItemArrLoading([]) },200)
  // clear timer
   return () => clearTimeout(timer);
}, []);

const updateItemBackground=(val)=>{
   // ;setReloadList2((prev) => ({ ...prev, [dynamicId]: false }));setTimeout(()=>{setReloadList2((prev) => ({ ...prev, [dynamicId]: true }));},0)
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {...item,  itemBackground:val }; } return item;
    });setItemBackground(prev => ({ ...prev, [dynamicId]: val  }));return updatedItems;
       });
   }
 const updateImagesData=(val)=>{
  setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {  ...item,  images:val };} return item; }); return updatedItems;
  });
}
const moveItemUp = (obj) => {
  setItemArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems.findIndex(item => item.myKey === obj?.myKey);

    if (index > 0) {
      // Swap with the item above it
      const temp = updatedItems[index - 1];
      updatedItems[index - 1] = updatedItems[index];
      updatedItems[index] = temp;
    }

    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      no: index + 1, // optional: update ordering number
    }));

    clearHistoryBeforeCurrent()
  // setting Current Schema
   updateSchema(reorderedItems);
   
//     setDynamicId(obj?.myKey); // set to the moved item
//     setCurrentItem(obj)
// setDynamicIdChange(false);setTimeout(()=>{
//       setDynamicIdChange(true);
    
//     },0)
  
    return reorderedItems;
  });
};
const moveItemDown = (obj) => {
  setItemArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems.findIndex(item => item.myKey === obj?.myKey);

    if (index !== -1 && index < updatedItems.length - 1) {
      // Swap with the item below
      const temp = updatedItems[index + 1];
      updatedItems[index + 1] = updatedItems[index];
      updatedItems[index] = temp;
    }

    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      no: index + 1, // optional: re-number items if needed
    }));
 clearHistoryBeforeCurrent()
  // setting Current Schema
   updateSchema(reorderedItems);
  
    // setDynamicId(obj?.myKey); // set to the moved item
    // setCurrentItem(obj)
    // setDynamicIdChange(false);setTimeout(()=>{
    //   setDynamicIdChange(true);
    
    // },0)
    
    return reorderedItems;
  });
};

const duplicateItem = (obj) => {
  
  setItemArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems.findIndex(item => item.myKey === obj?.myKey);

    if (index !== -1) {
      const originalItem = updatedItems[index];
      const duplicatedItem = {
        ...originalItem,
        id: Date.now(), // generate new unique ID
        myKey: originalItem.myKey + generateTimestamp(), // or use a better unique label
      };
  // console.log(originalItem)
      // Insert the duplicated item right after the original
      updatedItems.splice(index + 1, 0, duplicatedItem);

      const reorderedItems = updatedItems.map((item, idx) => ({
        ...item,
        no: idx + 1, // optional: re-number
      }));

      // do this for all state key updates 
      duplicateItemKey(duplicatedItem,duplicatedItem.myKey)

    
    // this code is for reloading status for settings component
   
   updateSchema(reorderedItems);
    //   setDynamicId(duplicatedItem.myKey); // focus the duplicated item
    // setCurrentItem(duplicatedItem)
    // setDynamicIdChange(false);setTimeout(()=>{
    //   setDynamicIdChange(true);
    
    // },0)
    
  // setting Current Schema
      return reorderedItems;
    }setItemArrLoading(itemArrLoads)
 setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
     
    },0)
    return prev;
  });
};

const deleteItem = (obj) => {
  setItemArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.filter(item => item.myKey !== obj?.myKey);

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      no: index + 1,
    }));

    // Update reloadList to reflect current state
    

    // Clear dynamicId if deleted item was focused
    if (obj?.myKey === dynamicId) {
      setDynamicId(null);
      
    }
const indexItem = itemArr?.findIndex(item => item.myKey === obj?.myKey);

    // setDynamicId(itemArr[indexItem-1]?.myKey); // set to the moved item
    // setCurrentItem(itemArr[indexItem-1])
    // setDynamicIdChange(false);setTimeout(()=>{
    //   setDynamicIdChange(true);
    
    // },0)

    
  // setting Current Schema
   updateSchema(reorderedItems);
    return reorderedItems;

  });
};

const duplicateItemKey=(item,key)=>{
 // this code is for adding new dynamic id to column array, 
   setColumnsList(prev => ({
      ...prev,
      [key]:item?.columns
    }));


    setScrollItems(prev => ({
      ...prev,
      [key]:item?.scrollItems
    }));
    setTitleFontSize(prev => ({
      ...prev,
      [key]:item?.titleFontSize
    }));
     setSubTitleFontSize(prev => ({
      ...prev,
      [key]:item?.subTitleFontSize
    })); setTitleFontColor(prev => ({
      ...prev,
      [key]:item?.titleFontColor
    }));
     setSubTitleFontColor(prev => ({
      ...prev,
      [key]:item?.subTitleFontColor
    }));
    setTitleFontWeight(prev => ({
      ...prev,
      [key]:item?.titleFontWeight
    }));
   setSubTitleFontWeight(prev => ({
      ...prev,
      [key]:item?.subTitleFontWeight
    }));
    setShowTitle(prev => ({
      ...prev,
      [key]:item?.showTitle
    }));
     setShowSubTitle(prev => ({
      ...prev,
      [key]:item?.showSubTitle
    }));
   setAspectRatio(prev => ({
      ...prev,
      [key]:item?.aspectRatio
    }));
    setimarginLeft(prev => ({
      ...prev,
      [key]:item?.imarginLeft
    }));
    setimarginTop(prev => ({
      ...prev,
      [key]:item?.imarginTop
    }));
    setmarginLeft(prev => ({
      ...prev,
      [key]:item?.marginLeft
    }));
     setmarginTop(prev => ({
      ...prev,
      [key]:item?.marginTop
    }));  setmarginBottom(prev => ({
      ...prev,
      [key]:item?.marginBottom
    }));
   setBorderRadius(prev => ({
      ...prev,
      [key]:item?.borderRadius
    }));
    setFontFamily(prev => ({
      ...prev,
      [key]:item?.fontFamily
    }));
   setTextAlignment(prev => ({
      ...prev,
      [key]:item?.textAlignment
    }));
   setItemBackground(prev => ({
      ...prev,
      [key]:item?.itemBackground
    }));
   setiWidth(prev => ({
      ...prev,
      [key]:item?.iWidth
    }));
    setTextPosition(prev => ({
      ...prev,
      [key]:item?.textPosition
    }));
  setApplyOverlay(prev => ({
      ...prev,
      [key]:item?.applyOverlay
    }));
  setOverlayTitleFontColor(prev => ({
      ...prev,
      [key]:item?.overlayTitleFontColor
    }));
  setOverlayBG(prev => ({
      ...prev,
      [key]:item?.overlayBG
    }));
   
  setItemVisibility(prev => ({
      ...prev,
      [key]:item?.itemVisibility
    }));
   

  setAbsoluteHorizontal(prev => ({
      ...prev,
      [key]:item?.absoluteHorizontal
    }));
  setAbsoluteHorizontalMargin(prev => ({
      ...prev,
      [key]:item?.absoluteHorizontalMargin
    }));
  setAbsoluteVertical(prev => ({
      ...prev,
      [key]:item?.absoluteVertical
    }));
  setAbsoluteVerticalMargin(prev => ({
      ...prev,
      [key]:item?.absoluteVerticalMargin
    }));
   
}
 const functGetNewItem=(dragIndex)=>{
  let newItem={};
 
  if(extractElementType(dragIndex)=="list1"){
    newItem = {
    no: itemArr.length + 1,myKey: dragIndex,
    id: generateTimestamp() + 2,itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}
          ,images:imagesList1,columns:3,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
         fontWeight:"700",iWidth:100,iHeight:80,
          titleFontSize:10, titleFontColor:{color:"rgba(23, 25, 25, 0.83)",alpha:1}, subTitleFontSize:8, subTitleFontColor:{color:"rgba(54, 55, 56,1)",alpha:1},
      titleFontWeight:"600", subTitleFontWeight:"500",showTitle:true, showSubTitle:true, 
          borderRadius:{value:5,resolution:"px"}, marginLeft:10,scrollItems:"Grid",
          marginTop:10,  marginBottom:10, imarginLeft:18, imarginTop:5, aspectRatio:"2/1",  textAlignment:"left"
          ,absoluteHorizontal:"",absoluteVertical:"bottom",absoluteHorizontalMargin:10,absoluteVerticalMargin:5,
          textPosition:"below",applyOverlay:false,overlayBG:{color:"rgba(39, 30, 30, 0.47)",alpha:0.5},
          overlayTitleFontColor:{color:"rgba(244, 250, 244, 1)",alpha:1},itemVisibility:"Both",
        } }

         if(extractElementType(dragIndex)=="list2"){ 
           
         newItem = {
    no: itemArr.length + 1,
    id: generateTimestamp() + 2,itemBackground:{color:"rgba(163, 249, 144, 0.4)",alpha:0.6},images:imagesList2,
    myKey: dragIndex,
    columns:2,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
     
         fontWeight:"700",iWidth:100,iHeight:80,  titleFontSize:11, titleFontColor:{color:"rgba(144, 202, 249,0.4)",alpha:1}, subTitleFontSize:8, subTitleFontColor:{color:"rgba(144, 202, 249,0.4)",alpha:1},
      titleFontWeight:"600", subTitleFontWeight:"500",showTitle:true, showSubTitle:true, 
           borderRadius:{value:10,resolution:"px"}, marginLeft:10,scrollItems:"Grid",
          marginTop:10,marginBottom:10,  imarginLeft:18, imarginTop:5, aspectRatio:"4/3", showText:true,  textAlignment:"center"
          
           ,absoluteHorizontal:"left",absoluteVertical:"top",absoluteHorizontalMargin:10,absoluteVerticalMargin:10,
          textPosition:"below",applyOverlay:false,overlayBG:{color:"rgba(144, 202, 249,0.15)",alpha:1},
          overlayTitleFontColor:{color:"rgba(244, 250, 244, 1)",alpha:1},itemVisibility:"Both",
        }}

 
   
        return newItem;
 }

const handleDrop = (e, dropIndex) => {
  // prevent duplicate 
  
  const dragIndex = e.dataTransfer.getData("dragIndex");
   
const isNullOrEmpty = (val) => {
  return val === null || val === undefined || val == '';
};

  if((isNullOrEmpty(dropIndex))) return;
  if((isNullOrEmpty(dragIndex))) return;

  if (dragIndex === dropIndex) return;
 
// set new Item As Per Item Type 
// alert(extractElementType(dragIndex))
let newItem = {}
let createItemStatus=false;
 if(extractElementType(dragIndex)=="list1")
  { createItemStatus=true;
   newItem =   functGetNewItem(dragIndex);
   
  } if(extractElementType(dragIndex)=="list2")
  {createItemStatus=true;
     newItem =   functGetNewItem(dragIndex);
     
  }  

  if(createItemStatus){
    // set dynamic keys for Duplicating Items
    duplicateItemKey(newItem,dragIndex);
setItemArrLoading(itemArrLoads)
    // this code is for reloading status for settings component
    setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
     
    },0)
  setItemArr((prev) => {
    let updatedArr = [...prev, newItem];
const updatedItems = [...updatedArr];
const indexOfSentItem = updatedItems.findIndex(item => item.myKey === dragIndex);
if (indexOfSentItem !== -1) {
 

  const [draggedItem] = updatedItems.splice(indexOfSentItem, 1);
  // alert(draggedItem?.no)
  updatedItems.splice(dropIndex, 0, draggedItem);
}
  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    myKey: item.myKey,
  }));

  // setting Current Schema
   updateSchema(reorderedItems);
  setItemArr(reorderedItems);
 
setHideReduUnDo(true)
 setDynamicId(dragIndex);
    setCurrentItem(newItem);setItemArrLoading(itemArrLoads)
    setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
    
    },0)
    return updatedArr;
  });

  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
}

};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
const setCurrentObject=(id,item)=>{
  
     setDynamicId(id);
     setCurrentItem(item);
             
    setItemArrLoading(itemArrLoads);
    setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
      // alert(columnsList[id]);
    },0)
  
}
   
    return <div  style={{marginTop:"-40px"}} >
     
     
   
   <div  ref={bodyWidthForMobile}  >
 
   
 <div className="gridForAppMobileRight"  >

   
           


    <div className="appMobileOuterGrid" style={{ minHeight:"70vh", position:"relative",}}  >
      <div>
        
        <div 
       
        className={`${!isVisible?"fixed-div-themes":"normal-div-last-themes"}  `}
        style={{ left:deviceWidth>551?!mainMenuStatus&&!openAppDesignPopUpInn?"160px":!mainMenuStatus&&openAppDesignPopUpInn?"140px":mainMenuStatus&&openAppDesignPopUpInn?"230px":"300px":"0px",textAlign:"left",backgroundColor:"transparent",marginBottom:`${!isVisible?0:-divHeight}px `,marginTop:"-20px" }} // Move the div horizontally
      ><div className="mobile-container">
      
<div className="mobile-frame">
     
     <div className="side-buttons left">
     <div className="volume-button2"></div>
     <div className="volume-button"></div>
       <div className="volume-button"></div>
     </div>
     <div className="side-buttons right">
       <div className="power-button"></div>
     </div>

     <div className="mobile-top">
       <div className="camera"></div>
       <div className="speaker"></div>
     </div>

     <div className="mobile-screen" style={{paddingTop:"60px"}}>
      
       {
      reloadItems&&   
  currentSchema?.map((item,index) => ((
      
  <div  index={index} key={item?.id}  style={{ background:item?.itemBackground?.color,
    // borderTop:dynamicId==item?.myKey?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
    // borderBottom:dynamicId==item?.myKey?"2px solid rgba(144, 202, 249,1)":"2px solid transparent"
  }}
          >
       
            <div
       
onDragOver={(e) => { if(selectedItemIndex!==index){
  setHoveredDropZone(index);
    // handleDragOver(e, index)
  }
  }}
  onDrop={(e) => {setSelectedItemIndex(null);setHoveredDropZone(null);}}

             onDragStart={(e) =>{
              //  handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'pointer',
             
              
            }}  
              // onDragEnd={handleDragEnd}
onDragEnd={(e) =>{setSelectedItemIndex(null);setHoveredDropZone(null);}}
        

className={"hoverItemElement"  }
              
            >
              <div className={"hoverItemElementOuter"} style={{border:dynamicId==item?.myKey?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",borderRadius:"5px"}}> 
                
        

      <UIBlockRenderer  moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}} duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      currentIndex={currentIndex}
      item={item} dynamicId={dynamicId} 
            setCurrentObject={()=>{setCurrentObject(item?.myKey,item);;}}
           />

    
   <div className="showPlusElementOuter" > <div className="showPlusElement"  onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} style={{background:dynamicId==item?.myKey?"":""}}><div style={{padding:"5px",marginBottom:"-19px",width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.41)"}} ><Plus size={23} style={{width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.941)"}} color="#ffffff" /></div></div></div>
    
       
       
          </div>
          </div>
          <div
          className="drop-zone"
          onDragOver={(e) => {
            handleDragOver(e, index+1) // index+1 for add  below item
          }}
          onDrop={(e) =>{ handleDrop(e, index+1);setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
          style={{
            height: hoveredDropZone === index ?'50px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"10px",bottom:"10px",
            backgroundColor: hoveredDropZone === index ? '#ffffff ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(144, 202, 249,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"90%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"0px":"0px",display:"flex",justifyContent:"center",
           visibility:hoveredDropZone === index ?"visible":"hidden",fontSize:"14px",
          }}
        ><div style={{paddingTop:"15px",}}>Drop Element Here</div></div>
          </div>
     ))
     )
     }
      {itemArr?.length==0?<div>
     <div
          className="drop-zone posRelative hoverItemElement"
          onDragOver={(e) => {
            handleDragOver(e, itemArr?.length+1) // index+1 for add  below item
          }}
          onDrop={(e) =>{ handleDrop(e, itemArr?.length+1);}}
        
          style={{
            height:'150px',position:'relative',left:"5px",right:"5px",
            backgroundColor:  'rgba(144, 202, 249,0.2) ' , // Change color on hover
            border:  '2px dashed rgba(144, 202, 249,1) ' , // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginTop:"40px"
           
          ,marginBottom:"20px"
           
          ,display:"flex",justifyContent:"center",
           visibility:"visible",fontSize:"14px"
          }}
        ><div style={{paddingTop:"65px",}}>Drop Element Here</div><div className="showPlusElement"  onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} ><Plus size={23} style={{padding:"10px",position:"absolute",left:"42%",bottom:"-25px",width:"35px",height:"35px",borderRadius:"50%",background:"rgba(144, 202, 249,0.941)"}} color="#ffffff" /></div>
   </div></div>:""}
     </div>
<div className="mobile-bottom"></div>
     
   </div>
      </div> </div>  </div>
      </div>  <div><div  >
  
   </div><div><div className="gridForWhatsNextAfterYT3" style={{alignContent:"center",textAlign:"center",gap:"10px",width:"90%",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>  

          
          
          <AppMenuCardTwo  activeCard={activeCardElements}  icon={6} title ="Elements" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);}} />
    <AppMenuCardTwo  activeCard={activeCardDesign}   icon={2} title ="Design" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(true);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false); }} />
     <AppMenuCardTwo  activeCard={designContent}   icon={5} title ="Themes" onClickPopup={
   ()=>{ openDesignContent(true);setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false); }} /> 
    <AppMenuCardTwo  activeCard={activeCardScreens}   icon={4} title ="Screens" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(true);setActiveCardElements(false);;setActiveCardSettings(false); }} />
   </div>
   {activeCardDesign?<>
    {/* <ColorPalette   setColor={(color)=>handleAppSettings('themeColor',color)}  /> */}
   
     <DesignColorAll />
   
   </>:designContent?


      <DesignContentAll setopenAppDesignPopUpInn={(state)=>{setopenAppDesignPopUpInn(state);}} />

      :activeCardScreens?"Screens"
      :activeCardElements?<div className="gridForAppElements" style={{alignContent:"center",textAlign:"center",margin:"3px",gap:"2px",
  
    transition: 'transform 2s ease, opacity 1s ease'
  }}>
    
    <DesignElements />
   <div className="" style={{padding:"5px",border:"4px solid  #ffffff",borderRadius:"15px"}}>
    <div style={{background:"#ffffff",display:"flex",justifyContent:"left",borderRadius:"15px",marginBottom:"10px"}} >  
                           
                          
           
 <div style={{color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
       Elements</div>       </div>      
<div className="appShowElementsScroller" >
     <div style={{background:"#ffffff",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)",borderRadius:"15px",marginBottom:"20px",paddingBottom:"20px"}}
      onMouseEnter={
                      ()=>handleMouseEnter("#ffffff ","#222 ","Double-click to select, then drag it near the mobile and drop it.")}
      onMouseLeave={handleMouseLeave}>  
                           
                          <div draggable  onDragStart={(e) =>{ handleDragStart(e, `id-list1-${itemArr?.length+1}`);
              setDraggedIndex(`id-list1-${itemArr?.length+1}`);setSelectedItemIndex(`id-list1-${itemArr?.length+1}`);
             }}
             style={{ cursor: 'move', }}  
           onDrop={(e) => {handleDrop(e, `id-list1-${itemArr?.length+1}`);setSelectedItemIndex(null);}} onDragEnd={handleDragEnd}
            > <div style={{display:"flex",justifyContent:"left", color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
        List Type 1</div> 
              <img src={element1} style={
             {width:"90%",borderRadius:"20px", }} />
             
     </div>   
               </div>
               
      
     { 
     //"Item 2"
     }  <div style={{background:"#ffffff",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)",borderRadius:"15px",marginBottom:"20px",paddingBottom:"20px"}}
       onMouseEnter={
                      ()=>handleMouseEnter("#ffffff ","#222 ","Double-click to select, then drag it near the mobile and drop it.")}
      onMouseLeave={handleMouseLeave}>  
                        
     <div draggable  onDragStart={(e) =>{ handleDragStart(e, `id-list2-${itemArr?.length+1}`);
              setDraggedIndex(`id-list2-${itemArr?.length+1}`);setSelectedItemIndex(`id-list2-${itemArr?.length+1}`);
             }}
             style={{ cursor: 'move', }}  
           onDrop={(e) => {handleDrop(e, `id-list2-${itemArr?.length+1}`);setSelectedItemIndex(null);}} onDragEnd={handleDragEnd}
            ><div style={{display:"flex",justifyContent:"left", color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
        List Type 2</div> 
             <img src={element3} style={
             {width:"80%",borderRadius:"20px"  }} />
                
     </div>   
           
     </div>
     
     { 
     //"Item 3"
     }  <div style={{background:"#ffffff",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)",borderRadius:"15px",marginBottom:"20px",paddingBottom:"20px"}}>  
                        
     <div draggable  onDragStart={(e) =>{ handleDragStart(e, `id-list2-${itemArr?.length+1}`);
              setDraggedIndex(`id-list2-${itemArr?.length+1}`);setSelectedItemIndex(`id-list2-${itemArr?.length+1}`);
             }}
             style={{ cursor: 'move', }}  
           onDrop={(e) => {handleDrop(e, `id-list2-${itemArr?.length+1}`);setSelectedItemIndex(null);}} onDragEnd={handleDragEnd}
            ><div style={{display:"flex",justifyContent:"left", color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
        List Type 3</div> 
             <img src={element2} style={
             {width:"80%",borderRadius:"20px"  }} />
                
     </div>   
           
     </div>
     
     
      </div>
</div>
<div style={{padding:"5px",border:"4px solid #ffffff",borderRadius:"15px"}}>
 {!hideReduUnDo?<div style={{ marginBottom: 12 }}>
        <button className="classSettBtns" style={{background:canUndo?"rgba(144, 202, 249,1)":"#fff",color:!canUndo?"rgba(144, 202, 249,1)":"#fff"}} onClick={()=>{undo();
         setDynamicIdChange(false); setItemArrLoading(itemArrLoads);setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0); 
        }}
         disabled={!canUndo}>↩ Undo</button>
        <button className="classSettBtns"  style={{background:canRedo?"rgba(144, 202, 249,1)":"#fff",color:!canRedo?"rgba(144, 202, 249,1)":"#fff"}} onClick={()=>{redo();
           setDynamicIdChange(false);setItemArrLoading(itemArrLoads); setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0);
         }} disabled={!canRedo}>↪ Redo</button>
        <button className="classSettBtns" style={{background:"rgba(86, 82, 131,0.7)",color:"#fff",border:"2px solid rgba(86, 82, 131,1)"}}  onClick={()=>{reset();
           setDynamicIdChange(false); setItemArrLoading(itemArrLoads);setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0);
         }}>♻ Reset</button>
         <button className="classSettBtns" style={{background:"rgba(7, 7, 7, 0.94)",color:"#fff",border:"2px solid rgb(12, 12, 12)"}}onClick={()=>{
           
         }}>Save</button>
         <button className="classSettBtns" style={{background:"rgba(86, 82, 131,0.7)",color:"#fff",border:"2px solid rgba(86, 82, 131,1)"}} onClick={()=>{
         }}>Preview</button>
      </div>:""}
 {  dynamicIdChange?
  currentSchema?.map((item,index) => ((
   <div  index={index} key={item?.id} > {dynamicId==item?.myKey?<div>

    <ListUISettings

          //  updateSchema={(value)=>updatedItems(value)}
  setItemArr={(val)=>{ setItemArr(val)   ;}}
  setItemArrCurrent={(val)=>{
    // updates redo , undo schema in history
    updateSchema(val) ;setHideReduUnDo(false)
  }}
   sendBackImagesArray={(val)=>{ updateImagesData(val)}}
  images={item?.images} dynamicId={dynamicId}
  scrollItems={item?.scrollItems} setScrollItems={(val)=>{ setScrollItems(prev => ({...prev, [dynamicId]: val})); }}
  columnsList={item?.columns} setColumnsList={(val)=>{ setColumnsList(prev => ({...prev,[dynamicId]: val}));
 
  } } 
  fontFamily={item?.fontFamily} setFontFamily={(val)=>{setFontFamily(prev => ({...prev,[dynamicId]: val}));  }}
   fontWeight={item?.fontWeight} setFontWeight={(val)=>{ setFontWeight(prev => ({ ...prev, [dynamicId]: val  }));}}
    iWidth={item?.iWidth} setiWidth={(val)=>{setiWidth(prev => ({ ...prev, [dynamicId]: val  }));}} 
    iHeight={item?.iHeight} setiHeight={(val)=>{setiHeight(prev => ({ ...prev, [dynamicId]: val  }));}}
         titleFontSize={item?.titleFontSize} setTitleFontSize={(val)=>{setTitleFontSize(prev => ({ ...prev, [dynamicId]: val  }));}} 
    subTitleFontSize={item?.subTitleFontSize} setSubTitleFontSize={(val)=>{setSubTitleFontSize(prev => ({ ...prev, [dynamicId]: val  }));}}
    titleFontColor={item?.titleFontColor} setTitleFontColor={(val)=>{setTitleFontColor(prev => ({ ...prev, [dynamicId]: val  }));}} 
    subTitleFontColor={item?.subTitleFontColor} setSubTitleFontColor={(val)=>{setSubTitleFontColor(prev => ({ ...prev, [dynamicId]: val  }));}}
      titleFontWeight={item?.titleFontWeight} setTitleFontWeight={(val)=>{setTitleFontWeight(prev => ({ ...prev, [dynamicId]: val  }));}} 
    subTitleFontWeight={item?.subTitleFontWeight} setSubTitleFontWeight={(val)=>{setSubTitleFontWeight(prev => ({ ...prev, [dynamicId]: val  }));}}  
  
    borderRadius={item?.borderRadius}setBorderRadius={(val)=>{setBorderRadius(prev => ({ ...prev, [dynamicId]: val  }));}}
     marginLeft={item?.marginLeft} setmarginLeft={(val)=>{setmarginLeft(prev => ({ ...prev, [dynamicId]: val  }));}}
    marginTop={item?.marginTop} setmarginTop={(val)=>{setmarginTop(prev => ({ ...prev, [dynamicId]: val  }));}} 
    marginBottom={item?.marginBottom} setmarginBottom={(val)=>{setmarginBottom(prev => ({ ...prev, [dynamicId]: val  }));}} 
    imarginLeft={item?.imarginLeft} setimarginLeft={(val)=>{setimarginLeft(prev => ({ ...prev, [dynamicId]: val  }));}}
    imarginTop={item?.imarginTop} setimarginTop={(val)=>{setimarginTop(prev => ({ ...prev, [dynamicId]: val  }));}}
    aspectRatio={item?.aspectRatio} setAspectRatio={(val)=>{setAspectRatio(prev => ({ ...prev, [dynamicId]: val  }));}}
    showTitle={ item?.showTitle} setShowTitle={(val)=>{setShowTitle(prev => ({ ...prev, [dynamicId]: val  }));}}
   showSubTitle={ item?.showSubTitle} setShowSubTitle={(val)=>{setShowSubTitle(prev => ({ ...prev, [dynamicId]: val  }));}}
    textAlignment={item?.textAlignment} setTextAlignment={(val)=>{ setTextAlignment(prev => ({ ...prev, [dynamicId]: val  }));}}

     textPosition={item?.textPosition} setTextPosition={(val)=>{ setTextPosition(prev => ({ ...prev, [dynamicId]: val  }));}}
   applyOverlay={item?.applyOverlay} setApplyOverlay={(val)=>{ setApplyOverlay(prev => ({ ...prev, [dynamicId]: val  }));}}
   overlayTitleFontColor={item?.overlayTitleFontColor} setOverlayTitleFontColor={(val)=>{ setOverlayTitleFontColor(prev => ({ ...prev, [dynamicId]: val  }));}}
   overlayBG={item?.overlayBG} setOverlayBG={(val)=>{ setOverlayBG(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteHorizontal={item?.absoluteHorizontal} setAbsoluteHorizontal={(val)=>{ setAbsoluteHorizontal(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteHorizontalMargin={item?.absoluteHorizontalMargin} setAbsoluteHorizontalMargin={(val)=>{ setAbsoluteHorizontalMargin(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteVertical={item?.absoluteVertical} setAbsoluteVertical={(val)=>{ setAbsoluteVertical(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteVerticalMargin={item?.absoluteVerticalMargin} setAbsoluteVerticalMargin={(val)=>{ setAbsoluteVerticalMargin(prev => ({ ...prev, [dynamicId]: val  }));}}
itemVisibility={item?.itemVisibility} setItemVisibility={(val)=>{ setItemVisibility(prev => ({ ...prev, [dynamicId]: val  }));}}

    itemBackground={item?.itemBackground} setItemBackground={(val)=>{ updateItemBackground(val);}}
    />
    </div>:"" }
</div>))):<ListUISettingsLoading/>}
  
 {/* { flattenedDataLoading?.map((item, index) =>  */}
         {/* (<div  index={index} key={index}  > */}
{/* <ListUISettingsLoading/> */}
{/*             
<div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"5px",height:"17px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInn"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div> */}
     
       {/* </div>))} */}
        {!dynamicId?"You Have Not Selected Any Element For Edit":""}
</div>
</div> 
      :activeCardSettings?" Settings"  
      :""}
   </div>
</div>
<div  className="fix-menu-theme-right-app" style={fixMenuAppRightHide}>  
<AppMenuCard  activeCard={{}}  icon={9} title ="open" onClickPopup={
          ()=>{closeFixMenuAppRight(false);  }} /></div>
<div  className="fix-menu-theme-right-app" style={fixMenuAppRightShow}>  
<AppMenuCard  activeCard={{}}  icon={8} title ="close" onClickPopup={
          ()=>{closeFixMenuAppRight(true);  }} />
          <AppMenuCard  activeCard={activeCardElements}  icon={6} title ="Elements" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);  }} />
 
<AppMenuCard  activeCard={activeCardDesign}  icon={2} title ="Design" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardDesign(true);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false);   }} />
  <AppMenuCard  activeCard={designContent}  icon={5} title ="Themes" onClickPopup={
          ()=>{openDesignContent(true);setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false);  }} />
<AppMenuCard  activeCard={activeCardScreens}  icon={4} title ="Screens" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(true);setActiveCardElements(false);;setActiveCardSettings(false);    }} />
          {/* <AppMenuCard  activeCard={activeCardElements}  icon={6} title ="Themes" onClickPopup={
          ()=>{openDesignContent(false);setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);  }} /> */}
 <AppMenuCard  activeCard={activeCardSettings}  icon={7} title ="Settings" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(true);  }} />
   </div>
      </div><div style={{padding:"10px",}} ref={bottomDivBoxRef}></div>


{/* <div  style={{height:"580px"}}></div> */}
</div><div>
      </div>
 

<style>{`#hideMenuBar{display:none !important}`}</style>
    
    </div>

}
export default AppSettings;
